export const Form = {
  nomeApresentacao: "",
  login: "",
  ativoConta: "S",
  pessoa: {
    nomePessoa: "",
    nomeApresentacao: "",
    descEmail: "",
    numrCpf: "",
    numrTelefonePessoal: "",
    numrTelefoneCelular: "",
    dataNascimento: "",
    flagSexo: "",
    flagOrigem: "MONITORARAG",
    endrTipoLogradouro: "",
    endrLogradouro: "",
    endrBairro: "",
    endrComplemento: "",
    numrCep: "",
    endrNumero: "",
    matricula: "",
    flagServidor: "N",
    flagEmpregadoPublico: "N",
  },
  perfis: [],
};

export const FormVinculo = {
  idenVinculo: "",
  numrVinculo: "",
  descVinculo: "",
  statVinculo: "ATIVO",
  tipoVinculo: {
    idenTipoVinculo: 3,
    nomeRole: "EXTERNO",
    descTipoVinculo: "Externo",
  },
  orgao: null,
  unidade: { idenUnidade: null, descUnidade: null },
  cargo: null,
  pessoa: {
    idenPessoa: null,
  },
};

const url = "/seguranca/contasacesso";
const id = "id";

const urlVinculo = "/vinculos";
const idVinculo = "idenVinculo";

export function buscarPeloCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${codigo}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisar(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}?${filtro}`).then((res) => {
      resolve(res.data);
    });
  });
}

/*export function pesquisarAll() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}`).then((res) => {
            resolve(res.data);
        })
    })
}*/

/*
    buscar os perfis de acesso disponíveis
*/
export function buscarPerfisdeAcesso() {
  return new Promise((resolve, reject) => {
    /*window.$http.get(`/seguranca/perfilacessos`).then((res) => {
            resolve(res.data);
        })*/

    window.$http.get(`/seguranca/perfilacessos/all`).then((res) => {
      resolve(res.data.content);
    });
  });
}

export function listarPerfilSitemaLogado() {
  return new Promise((resolve, reject) => {
    /*window.$http.get(`/seguranca/perfilacessos`).then((res) => {
            resolve(res.data);
        })*/

    window.$http.get(`/seguranca/perfilacessos/listarPerfilSitemaLogado`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarPerfisdeAcessoUsuario(filtro) {
  return new Promise((resolve, reject) => {
    window.$http.get(`/seguranca/contasacesso/${filtro.id}/perfis `).then((res) => {
      resolve(res.data);
    });
  });
}

export function atualizarPerfil(registro) {
  return new Promise((resolve, reject) => {
    window.$http.post(`/seguranca/perfilacessos`, JSON.stringify(registro)).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarNomeCPF(inputValue, size, page) {
  let bodyValue = {
    nome: inputValue,
    pesquisarTodoNome: true,
  };
  if (inputValue) {
    return new Promise((resolve, reject) => {
      window.$http
        .post(`${url}/buscarNomeEmailCpf?size=${size}&page=${page}`, JSON.stringify(bodyValue))
        .then((res) => {
          resolve(res.data);
        });
    });
  } else {
    return new Promise((resolve, reject) => {
      window.$http.get(`${url}`).then((res) => {
        resolve(res.data);
      });
    });
  }
}
export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] != 0) {
      await atualizar(parm).then((res) => {
        resolve({ ...res, type: "UPD" });
      });
    } else {
      await criar(parm).then((res) => {
        resolve({ ...res, type: "INS" });
      });
    }
  });
}

export function remover(data) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${data[id]}`).then((res) => {
      resolve();
    });
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

function buscarPerfilVinculo(vinc) {
  return new Promise((resolve, reject) => {
    window.$http.get(`/seguranca/perfilvinculos/vinculo/${vinc.idenVinculo}`).then((res) => {
      let vinc_temp = {
        id: vinc.idenVinculo,
        ...vinc,
        perfil: [...res.data],
      };
      if (res.data.length > 0) {
        vinc_temp.nomePerfilAcesso = res.data[0].nomePerfilAcesso;
      }
      resolve(vinc_temp);
    });
  });
}

export function buscarVinculoAndPerfil(idenPessoa) {
  let res = window.$http.get(`/vinculos/pessoa/${idenPessoa}`).then((res) => {
    let cDadosVinculos_temp = res.data;
    let listPromise = [];

    cDadosVinculos_temp.forEach((vinc) => {
      listPromise.push(buscarPerfilVinculo(vinc));
    });

    return Promise.all(listPromise);
  });

  return res;
}

export function alterarPerfilUsuario(jsonVinculoPerfil) {
  return new Promise((resolve, reject) => {
    window.$http.put(`/seguranca/perfilacessos/vinculosNivel`, JSON.stringify(jsonVinculoPerfil)).then((res) => {
      resolve(res.data);
    });
  });
}

export function removerPerfilUsuario(jsonIdenPerfilVinculo) {
  return new Promise((resolve, reject) => {
    window.$http
      .put(`/seguranca/perfilvinculos/remover/nivelPerfil`, JSON.stringify(jsonIdenPerfilVinculo))
      .then((res) => {
        resolve(res.data);
      });
  });
}

export function buscarTiposVinculo() {
  return new Promise((resolve, reject) => {
    window.$http.get(`/tipovinculos/all`).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvarVinculo(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${urlVinculo}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}
